import { v4 as uuid } from 'uuid';
import { Transaction } from '../types';
import { storage } from '~app/shared/storage';

export const DEFAULT_TRANSACTION_KEY = 'SIGN_IN';

export function createTransaction(
  data: Pick<Transaction, 'codeVerifier' | 'targetUrl'>,
  key: string = DEFAULT_TRANSACTION_KEY,
): Transaction {
  return storage.save<Transaction>(key, { id: uuid(), ...data });
}

export function getTransactionById(
  id: string,
  key: string = DEFAULT_TRANSACTION_KEY,
): Transaction | void {
  const transaction: Transaction = storage.load(key);

  if (!transaction || transaction.id !== id) {
    return;
  }

  return transaction;
}

export function isTransactionCreated(key: string = DEFAULT_TRANSACTION_KEY): boolean {
  return !!storage.load(key);
}

export function patchTransactionById(
  data: Partial<Transaction>,
  id: string,
  key: string = DEFAULT_TRANSACTION_KEY,
): Transaction | void {
  const transaction = getTransactionById(id);

  if (!transaction) {
    return;
  }

  return storage.save<Transaction>(key, { ...transaction, ...data });
}

export function removeTransaction(key: string = DEFAULT_TRANSACTION_KEY) {
  storage.remove(key);
}
